import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import Chart from "react-apexcharts";

import GroupedColumnChart from "./revenuegraph";
import moment from "moment";

const Salesanlytics = (props) => {
  const {
    cancelBooking,
    ongoingBooking,
    completeBooking,
    upcomingBooking,
    DashboardData,
  } = props;

  const [weeklyBookings, setWeeklyBookings] = useState(null)

  useEffect(() => {
    if (DashboardData?.weeklyBookings) {
      setWeeklyBookings(DashboardData?.weeklyBookings);
    }
  }, [DashboardData?.weeklyBookings])

  const options = {
    chart: {
      type: "pie",
    },
    labels: ["Pending", "Confirmed", "Completed", "Canceled"],
    legend: {
      position: "bottom",
    },
  };

  const series = [
    upcomingBooking,
    ongoingBooking,
    completeBooking,
    cancelBooking,
  ];
  return (
    <>
      <Col lg={6} md={6} sm={12}>
        <GroupedColumnChart
          bookingReport={weeklyBookings}
        />
      </Col>
      <Col lg={6} md={6} sm={12}>
        <div className="cardCstm p-3 border h-100 rounded">
          <div className="cardHead m-0 pb-2 d-flex align-items-center justify-content-between gap-10">
            <h6 className="m-0 fw-sbold themeBlue">Bookings Status</h6>
            <p className="text-muted m-0 fw-sbold themeBlue">Last 7 days </p>
          </div>
          <div className="Sales_analytics_left border-0 w-100">
            <Chart
              options={options}
              series={series}
              type="pie"
              className="w-100"
              // width="400"
              height={300}
            />
          </div>
        </div>
      </Col>
    </>
  );
};

export default Salesanlytics;
